export default "__VITE_ASSET__Op2nAWZS__"